import { useEffect, useState } from "react";
import { useTheme } from "@mui/material";

import { Chart as ChartJS, ArcElement, Tooltip, Legend, Title } from "chart.js";
import { Doughnut } from "react-chartjs-2";

ChartJS.register(ArcElement, Tooltip, Legend, Title);

export default function DoughnutChart(props) {
  const { hideLegend, heading, label, color } = props;

  const theme = useTheme();
  const [data, setData] = useState(null);
  const options = {
    responsive: true,

    plugins: {
      legend: {
        [hideLegend ? "display" : "position"]: hideLegend ? false : "top",
      },
      title: {
        display: Boolean(heading),
        text: heading || label || "Doughnut Chart",
      },
    },
  };
  useEffect(() => {
    let labels = [];
    let datasets = [];
    if (props.data?.length) {
      labels = props.data.map((el) => el.x);

      datasets = [
        {
          label: label || "Doughnut Chart",
          data: props.data.map((el) => el.y),
          backgroundColor: props.data.map(
            (el, index) =>
              el.backgroundColor ||
              (color && color.includes("#")
                ? color
                : theme.palette[
                    el.color || color || `chartColor${(index % 9) + 1}`
                  ].main)
          ),
          borderColor: props.data.map(
            (el, index) =>
              el.borderColor ||
              (color && color.includes("#")
                ? color
                : theme.palette[
                    el.color || color || `chartColor${(index % 9) + 1}`
                  ].dark)
          ),
          borderWidth: 1,
        },
      ];
    }

    setData({
      labels,
      datasets,
    });
    // eslint-disable-next-line
  }, [props]);
  if (!data) return <></>;
  return <Doughnut options={options} data={data} />;
}
